import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  PaginationForm: () => [
    import(
      './viewer/skinComps/PaginationForm/PaginationForm.skin' /* webpackChunkName: "Pagination_PaginationForm" */
    ),
    import(
      './viewer/Pagination.controller' /* webpackChunkName: "Pagination_PaginationForm" */
    ),
  ],
  PaginationStrip: () => [
    import(
      './viewer/skinComps/PaginationStrip/PaginationStrip.skin' /* webpackChunkName: "Pagination_PaginationStrip" */
    ),
    import(
      './viewer/Pagination.controller' /* webpackChunkName: "Pagination_PaginationStrip" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Pagination', UiTypes),
};

export default entry;
